import {Component, computed, inject, input} from '@angular/core';
import {QuantityLamellaAreaComponent} from "./quantity-lamella-area/quantity-lamella-area.component";
import {LamelareaStore} from "../../../../../shared/product-card/product-card/lamelarea.store";

@Component({
  selector: 'app-quantity-single-group',
  standalone: true,
  imports: [
    QuantityLamellaAreaComponent
  ],
  templateUrl: './quantity-single-group.component.html',
  styleUrl: './quantity-single-group.component.scss'
})
export class QuantitySingleGroupComponent {
  readonly lamellaAreaStore = inject(LamelareaStore);
  groupId = input<string | null>(null);

  lamellaAreas = computed(() => {
    return this.groupId() ? this.lamellaAreaStore.getLamelareas(this.groupId()) : this.lamellaAreaStore.getAllLamelareas();

  })
}
